import React, { useState } from 'react';
import { Box, Typography, Grid, Paper, Switch, FormControlLabel, IconButton } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import BarChartIcon from '@mui/icons-material/BarChart';
import AiOperationsCenter from './chats/AiOperationsCenter';

export default function AiDashboard({ agentMode, waNumber, isActive }) {
    // Estado para el control global (Llave 1)
    const [isGlobalBotActive, setIsGlobalBotActive] = useState(isActive);

    const handleGlobalToggle = (event) => {
        const checked = event.target.checked;
        setIsGlobalBotActive(checked);
        // Aquí luego llamaremos a tu API para actualizar 'is_active' o 'agent_mode' en merchant_channel_configs
    };

    return (
        <Box sx={{ p: 3 }}>
            {/* Cabecera del Dashboard */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Box>
                    <Typography variant="h5" fontWeight="700">Centro de Operaciones IA</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Gestionando: {waNumber || 'Cargando número...'}
                    </Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={2}>
                    <Typography variant="subtitle2" color={isGlobalBotActive ? 'success.main' : 'error.main'} fontWeight="bold">
                        {isGlobalBotActive ? 'Agente Global: En Línea' : 'Agente Global: Pausado'}
                    </Typography>
                    <IconButton>
                        <SettingsIcon />
                    </IconButton>
                </Box>
            </Box>

            {/* Tarjetas de Estadísticas (KPIs) */}
            <Grid container spacing={3} mb={4}>
                {/* Tarjeta 1: Control de Modo Global */}
                <Grid item xs={12} md={4}>
                    <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%', borderLeft: '4px solid #3b82f6' }}>
                        <Typography variant="caption" color="text.secondary" fontWeight="600" textTransform="uppercase">
                            Control Global del Agente
                        </Typography>
                        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
                            <Typography variant="h6" fontWeight="600">
                                {isGlobalBotActive ? agentMode === 'linear' ? 'Lineal' : 'Conversacional' : 'Modo Manual'}
                            </Typography>
                            <Switch 
                                checked={isGlobalBotActive} 
                                onChange={handleGlobalToggle}
                                color="primary" 
                            />
                        </Box>
                    </Paper>
                </Grid>

                {/* Tarjeta 2: Mensajes Procesados */}
                <Grid item xs={12} md={4}>
                    <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%', borderLeft: '4px solid #10b981' }}>
                        <Typography variant="caption" color="text.secondary" fontWeight="600" textTransform="uppercase">
                            Mensajes Procesados (Mes)
                        </Typography>
                        <Typography variant="h4" fontWeight="700" mt={1}>
                            -
                        </Typography>
                    </Paper>
                </Grid>

                {/* Tarjeta 3: Estadísticas Detalladas */}
                <Grid item xs={12} md={4}>
                    <Paper 
                        elevation={0} 
                        sx={{ 
                            p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%', 
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer', '&:hover': { backgroundColor: '#f9fafb' }
                        }}
                    >
                        <BarChartIcon sx={{ color: '#6b7280', mb: 1 }} />
                        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
                            Ver Estadísticas Detalladas
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>

            {/* Aquí inyectamos el visor de conversaciones que acabamos de crear */}
            <Typography variant="h6" fontWeight="700" mb={2}>Actividad Reciente</Typography>
            <AiOperationsCenter />

        </Box>
    );
}